import request from 'config/apiConfig';

export const getClicks = () => {
  return request.get(`collector/clicks/marketer?page=0&size=2000&sort=created,DESC`, {});
};

export const getInsights = (session: string, placement: string) => {
  return request.put(`collector/insights`, { session, placement });
};

export const getStreamsByChannel = (channelId: string) => {
  return request.get(`channel/streams/channel`, {
    params: { id: channelId, size: 1000, sort: 'created,desc' }
  });
};

export const getPlacementsByStream = (streamnId: string) => {
  return request.get(`channel/placements/stream`, {
    params: { id: streamnId, size: 1000, sort: 'created,desc' }
  });
};

export const getChannelsByMarketer = (marketerId: string) => {
  return request.get(`channel/channels/marketer`, {
    params: { id: marketerId, size: 1000, sort: 'created,desc' }
  });
};

export const getAllCurationsByMarketer = () => {
  return request.get(`content/curations`, {
    params: { size: 1000, sort: 'created,asc' }
  });
};

export const updateCuration = (id: string, data: any) => {
  return request.put(`recommend/curations/${id}`, data);
};

export const createCuration = (data: any) => {
  return request.post(`content/curations`, data);
};

export const deleteCuration = (id: any) => {
  return request.delete(`recommend/curations/${id}`);
};

export const getCurationDetails = (id: string) => {
  return request.get(`content/curations/${id}`);
};

export const getAllSubCurationsByCuration = async (curationId: string, curationType: string) => {
  return await request.get(`recommend/${curationType}/${curationId}/all`, {
    params: { size: 1000, sort: 'created,asc' }
  });
};

export const createSubCuration = (curationId: string, curationType: string, data: any) => {
  return request.post(`recommend/${curationType}/${curationId}`, data);
};

export const updateSubCuration = (subCurationId: string, curationType: string, data: any) => {
  return request.put(`recommend/${curationType}/${subCurationId}`, data);
};

export const deleteSubCuration = (subCurationId: string, curationType: string) => {
  return request.delete(`recommend/${curationType}/${subCurationId}`);
};

export const getSubCurationQnAs = (subCurationId: string, curationType: string) => {
  return request.get(`recommend/qas/all?${curationType}=${subCurationId}`, {
    params: { size: 1000, sort: 'created,asc' }
  });
};

export const updateQnA = (qnAid: string, data: any) => {
  return request.put(`recommend/qas/${qnAid}`, data);
};

export const addQnA = (subCurationId: string, curationType: string, data: any) => {
  return request.post(`recommend/qas?${curationType}=${subCurationId}`, data);
};

export const deleteQnA = (qnAid: string) => {
  return request.delete(`recommend/qas/${qnAid}`);
};

export const getCurations = () => {
  return request.get(`content/curations`, {
    params: { size: 1000, sort: 'created,asc' }
  });
};

export const getChaptersByCuration = ({ curationId }: { curationId: string }) => {
  return request.get(`/content/chapters`, {
    params: { curation: curationId }
  });
};

export const getChapterDetails = (id: string) => {
  return request.get(`content/chapters/${id}`);
};

export const createChapter = (data: any) => {
  return request.post(`content/chapters`, data);
};

export const updateChapter = (chapterId: string, data: any) => {
  return request.put(`content/chapters/${chapterId}`, data);
};

export const updateChapterQAs = (chapterId: string, qas: any[]) => {
  return request.put(`content/chapters/${chapterId}/qas`, { qas });
};

export const simulateQuestionForSuperfeed = (
  superfeedId: string,
  data: { curationId: string; chapterId: string; questionId: string }
) => {
  return request.post(`partner/superfeeds/${superfeedId}/simulate`, data);
};

export const deleteChapter = (chapterId: string) => {
  return request.delete(`content/chapters/${chapterId}`);
};
